import { getShouldUseNpsIdentity } from '~/services/posthog/FeatureFlagUtils';
import { submitFreeTextFeedback } from '../clients/submitFreeTextFeedback';
import { submitMonolithNpsReview } from '../clients/submitMonolithNpsReview';
import { submitNpsReview } from '../clients/submitNpsReview';
import type { TNpsAnswer } from '../types/NpsReview';
import type { ISubmitNpsReviewParams } from '../types/SubmitNpsReview.parameters';

const SKIP_SCORE = -1;

/**
 * Records one NPS answer and resolves with what was recorded.
 *
 * With `GOTU-7479-nps-identity` on, auth-service gets a real skipped record or
 * the score; with it off, the monolith gets the score, `-1` for a skip, as it
 * always has. The optional free-text message goes to the monolith either way,
 * after the answer, so a failed message post leaves the flow failed rather
 * than half-thanked.
 */
export const submitNpsAnswer = async ({
  npsScore,
  message,
}: ISubmitNpsReviewParams): Promise<TNpsAnswer> => {
  const isSkip = npsScore === SKIP_SCORE;
  let answer: TNpsAnswer;

  if (getShouldUseNpsIdentity()) {
    answer = isSkip ? { skipped: true } : { score: npsScore };
    await submitNpsReview(answer);
  } else {
    answer = { score: npsScore };
    await submitMonolithNpsReview(npsScore);
  }

  if (message) {
    await submitFreeTextFeedback(message);
  }

  return answer;
};
